// extracted by mini-css-extract-plugin
module.exports = {"bg":"_38Oww"};